var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3632 6.42347C21.7146 6.07203 22.2842 6.07209 22.6356 6.42347C22.9871 6.77494 22.9871 7.34446 22.6356 7.69593L12.4999 17.8327L9.99891 15.3317L7.49989 17.8327L1.36317 11.6959C1.01179 11.3445 1.01173 10.7749 1.36317 10.4235C1.71461 10.072 2.28415 10.0721 2.63563 10.4235L7.49989 15.2868L8.72645 14.0592L6.36317 11.6959C6.01179 11.3445 6.01173 10.7749 6.36317 10.4235C6.71461 10.072 7.28415 10.0721 7.63563 10.4235L9.99891 12.7868L16.3632 6.42347C16.7146 6.07203 17.2842 6.07209 17.6356 6.42347C17.9871 6.77494 17.9871 7.34446 17.6356 7.69593L11.2723 14.0592L12.4999 15.2868L21.3632 6.42347Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double-check.61c8fb9b8f8e0f34e585d1032425b4a7.svg";
export { ForwardRef as ReactComponent };